export default __webpack_public_path__ + "static/media/cli-paul.032ab269.jpg";